var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiltArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63336 2.31129V6.35868C6.63336 6.72687 6.93184 7.02535 7.30003 7.02535C7.66822 7.02535 7.96669 6.72687 7.96669 6.35868L7.96669 0.368497C7.96669 0.184402 7.81746 0.0351638 7.63336 0.0351638L7.30322 0.0351639C7.30109 0.0351537 7.29896 0.0351537 7.29683 0.0351639L1.64317 0.035164C1.27498 0.035164 0.976507 0.333641 0.976507 0.701831C0.976507 1.07002 1.27498 1.3685 1.64317 1.3685H5.69054L0.228954 6.83008C-0.0313961 7.09043 -0.0313959 7.51254 0.228954 7.77289C0.489303 8.03324 0.911413 8.03324 1.17176 7.77289L6.63336 2.31129Z",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltArrow);
export default __webpack_public_path__ + "static/media/tilt_arrow.9391e14709e023c87ee8bb02fd5d1647.svg";
export { ForwardRef as ReactComponent };